const Priority = {
  REGULARNO: { label: 'Redovno', value: 0 },
  HITNO: { label: 'Hitno', value: 1 },
};

export default Priority;
